// extracted by mini-css-extract-plugin
export default {"skeleton":"TextComponent_skeleton__2HAp2"};